// extracted by mini-css-extract-plugin
export var li = "_ux-2";
export var ol = "_ux-1";
export var ul = "_ux-0";